import CommonTextField from "../../../../../../../common/components/functional/commonTextField/CommonTextField";

export const CustomInput = ({ ...props }) => (
  <CommonTextField
    {...props}
    inputProps={{
      style: {
        textAlign: "center",
      },
    }}
    sx={{
      width: "100px",
    }}
  />
);
